import Element from '../../../Prototype/UI/Element';
import Game from '../../../Game';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import { applyDefaultButtonAnimation } from '../../../System/UI/UIHelper';
import Renderable from '../../../Component/Renderable';
import ButtonComponent from '../../../Component/UI/ButtonComponent';
import AnimationComponent from '../../../Component/Animation';
import { IGameState } from '../../../State/Game/IGameState';
import { WorldDataHelper } from '../../../Utility/WorldDataHelper';
import StateComponent from '../../../Component/State';
import Arrow from '../../../Prototype/Level/Arrow';
import { Point } from 'pixi.js';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { TextAlignment } from '../../../Prototype/UI/TextAlignment';
import { addDragonbonesResources } from '../../../Utility/Resource/ResourceHelper';
import { DRAGONBONES_PATH } from '../../../Constants/Dragonbones';
import Armature from '../../../Prototype/Armature';
import { StartAnimationClip } from '../../../System/Animation/AnimationHelper';
import { tVector4 } from '../../../Utility/ArrayHelper';
import { DragonbonesFadeIn } from '../../../System/Animation/Clip';
const idleDBName: string = 'play_button';
const idleDBArmatureName: string = 'Armature';
const idleDBAnimationName: string = 'animtion0';

const textOffsets: tVector4 = [6, 0, 6, 0];

export default class NextLevelButton extends Element {
    private static _name: string;
    private static BTN_NAME: string = 'button';
    private static BACKGROUND_NAME: string = 'background';
    private static TEXT_NAME: string = 'text';
    private static IDLE_ARMATURE_NAME: string = 'next_level_button_idle_armature';
    private static STAR_NAME: string = 'star';

    public highestLevel: number;
    public arrowRenderable: Renderable;

    public create(params: { highestLevel: number; [key: string]: any }): void {
        NextLevelButton._name = params.name;

        this.highestLevel = params.highestLevel;

        super.create({
            name: params.name,
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                ...params.layout,
            },
            children: [
                {
                    name: NextLevelButton.BACKGROUND_NAME,
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [1, 1],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'blank',
                            },
                        },
                    ],
                    children: [
                        {
                            name: NextLevelButton.BTN_NAME,
                            layout: {
                                anchors: [0.5, 0.5, 0.5, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [-3, -2.5, -3, -2.5],
                                scale: [0.95, 0.95],
                            },
                            components: [
                                {
                                    type: 'input',
                                    data: {
                                        enabled: true,
                                        buttonMode: true,
                                        toggleable: true,
                                        tintOnDisable: true,
                                    },
                                },
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'button_round_play',
                                    },
                                },
                            ],
                            children: [
                                {
                                    name: NextLevelButton.TEXT_NAME,
                                    layout: {
                                        anchors: [0.5, 0.5, 0.5, 0.5],
                                        pivot: [0.5, 0.5],
                                        offsets: textOffsets,
                                        scale: [1, 1],
                                    },
                                    components: [
                                        {
                                            type: 'text',
                                            data: {
                                                text: String(this.highestLevel + 1),
                                                style: {
                                                    ...Game.style.getStyle('popup.green_btn'),
                                                    fontSize: 30,
                                                },
                                                bounds: [70, 80],
                                                align: TextAlignment.CENTER,
                                            },
                                        },
                                        {
                                            type: 'visibility',
                                            data: {
                                                hidden: this.highestLevel >= WorldDataHelper.maxLevel(),
                                            },
                                        },
                                    ],
                                },
                                {
                                    name: NextLevelButton.STAR_NAME,
                                    layout: {
                                        anchors: [0.5, 0.5, 0.5, 0.5],
                                        pivot: [0.5, 0.5],
                                        offsets: [7, 0, 0, 0],
                                        scale: [1, 1],
                                    },
                                    components: [
                                        {
                                            type: 'image',
                                            data: {
                                                cacheKey: 'play_button_star',
                                            },
                                        },
                                        {
                                            type: 'visibility',
                                            data: {
                                                hidden: this.highestLevel < WorldDataHelper.maxLevel(),
                                            },
                                        },
                                    ]
                                },
                            ],
                        },
                    ],
                },
            ],
            ...params,
        });
        this.addComponent(AnimationComponent);
        this.addComponent(StateComponent, {
            handleStateChanged: this.handleStateChanged.bind(this),
        });
        const button: GameObject = this.button;
        button.addComponent(ButtonComponent, {
            toggleable: true,
        });
        button.on(GameObjectEvent.SELECTED, this.onSelect.bind(this));
        button.on(GameObjectEvent.TOGGLED, this.onToggled.bind(this));
        applyDefaultButtonAnimation(button);

        // Add this logic to the super.create call and then only show if below the correct level
        const arrow: Arrow = GameObject.Instantiate(Arrow, {
            name: 'next_level_arrow',
            position: new Point(2, -80),
            scale: new Point(0.85, 0.85),
            clipName: 'ArrowBounceLoopIdle',
            meta: {
                speed: 400,
            },
            visible: params.highestLevel < 7,
        });
        this.arrowRenderable = arrow.getComponent<Renderable>(Renderable);
        this.background.addChild(arrow);
        // Add arrow if below level 7
        if (params.highestLevel < 7) {
        }

        this.loadDBAssets().then(this.onDBAssetsLoaded);
    }

    private onSelect(): void {
        PlayerActions.showLevelAutoFlowPopup({
            allowRandomizedLevelSelection: true,
        });
    }

    private onToggled(value: boolean): void {
        this.arrowRenderable.visible = !value && this.highestLevel < 7;
    }

    public get button(): GameObject {
        return this.findChildByName(NextLevelButton.BTN_NAME);
    }

    private get background(): GameObject | undefined {
        return this?.find(NextLevelButton.BACKGROUND_NAME);
    }

    private get idleArmature(): Armature | undefined {
        const armature = this.button?.find(NextLevelButton.IDLE_ARMATURE_NAME);
        return armature ? (armature as Armature) : undefined;
    }

    private get text(): GameObject {
        try {
            return this.findChildByName(NextLevelButton.TEXT_NAME);
        } catch (e) {
            console.warn(`${this.name}'s 'text' could not be found`);
        }
    }

    public handleStateChanged(state: IGameState): void {}

    private async loadDBAssets(): Promise<void> {
        addDragonbonesResources(idleDBName, `${DRAGONBONES_PATH}/NextLevelButton/`);
        await Game.resource.load();
    }

    private readonly onDBAssetsLoaded = () => {
        if (this.destroyed) return;

        const button = this.button;
        const idleArmature = GameObject.Instantiate(Armature, {
            name: NextLevelButton.IDLE_ARMATURE_NAME,
            dragonbonesName: idleDBName,
            armatureName: idleDBArmatureName,
            animationName: idleDBAnimationName,
            playOnStart: false,
            alpha: 0,
            position: new Point(button.container.width * 0.5, button.container.height * 0.5),
        });
        this.button.addChild(idleArmature);
        this.playIdleAnimation();
    };

    private readonly playIdleAnimation = () => {
        const armature = this.idleArmature;

        if (this.destroyed || !armature) return;

        StartAnimationClip(new DragonbonesFadeIn(armature));
    };

    public destroy() {
        super.destroy();
    }
}
